import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";

interface ReCaptchaProps {
  onChange: (token: string | null) => void;
}

const ReCaptcha: React.FC<ReCaptchaProps> = ({ onChange }) => {
  const sitekey = "6Lc4wxkqAAAAABvIreD7Wf5vxm0RCuEDy4xvbQGq";

  return (
    <div className="flex flex-col flex-grow items-center justify-center w-full">
      <ReCAPTCHA
        sitekey={sitekey}
        onChange={onChange}
      />
    </div>
  );
};

export default ReCaptcha;